/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
  // 포스팅 리스트
  async index(data: any) {
    return camelize(await $axios.get(`/posting`, { params: snakelize(data) }));
  },

  // 포스팅 상세
  async show(data: any) {
    return camelize(
      await $axios.get(`/posting/${data.postingId}`, {
        params: snakelize(data),
      })
    );
  },

  // 포스팅 작성
  async store(data: any) {
    return camelize(await $axios.post(`/posting`, snakelize(data)));
  },

  // 포스팅 수정
  async update(data?: any) {
    return camelize(await $axios.patch(`/posting/${data.id}`, snakelize(data)));
  },

  // 포스팅 신고
  async declare(data: any) {
    return camelize(await $axios.post(`/posting/declare`, snakelize(data)));
  },

  // 이미지 업로드
  async uploadImage(data?: any) {
    const formData = new FormData();
    formData.append("image", data.image);
    formData.append("brand_token", data.brandToken);
    return camelize(await $axios.post("/posting/images/upload", formData));
  },

  async cropImage(data?: any) {
    const formData = new FormData();
    formData.append("image", data.image);
    formData.append("brand_token", data.brandToken);
    formData.append("image_id", data.imageId);
    return camelize(await $axios.post("/posting/images/crop", formData));
  },

  async undoCrop(data?: any) {
    return camelize(
      await $axios.post("/posting/images/crop/undo", snakelize(data))
    );
  },
});
